import { reduxKey } from './constants';
function getNotificationState(state) {
    return state[reduxKey] || { default: [] };
}
export function getNotificationQueue(state, queue) {
    if (queue === void 0) { queue = 'default'; }
    return getNotificationState(state)[queue] || [];
}
export function getTopNotification(state, queue) {
    if (queue === void 0) { queue = 'default'; }
    return getNotificationQueue(state, queue)[0];
}
//# sourceMappingURL=selectors.js.map